import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import exandIcon from "../../assests/page/chevron-right.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import { useEffect, useState } from "react";
import { errorToast, successToast } from "../../utils/constants";
import PaymentMethods from "./paymentMethods";
import ERC20ABI from "../../utils/abis/ERC20.json";
import SECURITYABI from "../../utils/abis/Security.json";
import { ethers } from "ethers";
import { Cash } from "@verified-network/verified-sdk";
import Avatar from "react-avatar";
import { ChainConfig } from "../../utils/config";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { useGetSupportedCurrencies } from "../../hooks/currencies";
import SuccessPopup from "./success";
import { getUserCustodyBanks } from "../../services/contracts/clientContract";
import { useAppKit } from "@reown/appkit/react";
import PaymentProcess from "./paymentProcess";
import { blinkActiveBanks } from "../../utils/helpers/blink";
import { authenticateKYCStatus } from "../../utils/helpers/kyc";
import { authenticatePaymentToken } from "../../utils/helpers/utils";
import { useTranslation } from "react-i18next";

const WitdrawFunds = (props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState(props.amount || "");
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(
    props.selectedCurrency || {},
  );
  const [linkedBankIds, setLinkedBankIds] = useState([]);
  const [newSearchContent, setNewSearchContent] = useState(null);
  const [walletBalance, setWalletBalance] = useState(0.0);
  const [bankList, setBankList] = useState([]);

  const appKitModal = useAppKit();

  const { chainId, web3, provider, signer } = useNetworkStore();

  const { userAddress } = useUserStore();

  const {
    verifiedWalletDetails,
    custodyWalletDetails,
    setVerifiedWalletDetails,
  } = props.generalDataProps;

  const { getSupportedCurrenciesData, getSupportedCurrenciesLoading } =
    useGetSupportedCurrencies("withdraw-funds");

  useEffect(() => {
    (async () => {
      const handleBankList = async () => {
        setBankList(await blinkActiveBanks());
      };

      await handleBankList();
    })();
  }, []);

  useEffect(() => {
    const getBalance = async () => {
      const securityBalanceRaw = await new web3.eth.Contract(
        ERC20ABI,
        selectedCurrency?.address,
      ).methods
        .balanceOf(userAddress)
        .call();
      setWalletBalance(Number(ethers.utils.formatEther(securityBalanceRaw)));
    };

    if (userAddress && selectedCurrency?.address && web3) {
      getBalance();
    }
  }, [web3, userAddress, selectedCurrency]);

  useEffect(() => {
    const fetchUsersBankIds = async () => {
      let bankIds = [];
      await getUserCustodyBanks(chainId, userAddress, signer).then(
        async (res) => {
          if (res) {
            if (
              res.length > 0 &&
              res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
              )
            ) {
              const userIdRaw = res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
              )?.account;
              const userId = ethers.utils.parseBytes32String(userIdRaw);
              bankIds.push({
                id: userId,
                providerType: "moneyhub",
              });
            }

            if (
              res.length > 0 &&
              res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "BLINK"?.toLowerCase(),
              )
            ) {
              const userIdRaw = (res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "BLINK"?.toLowerCase(),
              )).account;
              const userId = ethers.utils.parseBytes32String(userIdRaw);
              bankIds.push({
                id: userId,
                providerType: "blink",
              });
            }
          }
        },
      );
      setLinkedBankIds(bankIds);
    };

    if (chainId && userAddress && signer) {
      fetchUsersBankIds();
    }
  }, [chainId, provider, signer, userAddress]);

  const handleAddFundsButtonDisplay = () => {
    const button = document.getElementById("withdraw-funds-popup-button");
    if (
      button &&
      document.getElementById("add-funds-popup-input").value.length > 0 &&
      Number(document.getElementById("add-funds-popup-input").value) > 0 &&
      selectedCurrency?.address > 0
    ) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  const handleChooseCurrencyButtonDisplay = () => {
    const button = document.getElementById("choose-currency-popup-button");
    if (button && selectedCurrency.isClicked) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  const handleWithdrawFunds = async (
    selcetedBank,
    setCustomPopupPosition,
    setCustomPopupContent,
    setShowCustomPopup,
  ) => {
    setCustomPopupPosition("flex-end");
    setCustomPopupContent(<PaymentProcess title={"Checking KYC status"} />);
    setShowCustomPopup(true);
    await authenticateKYCStatus(
      chainId,
      userAddress,
      web3,
      appKitModal,
      props.setPopupContent,
      props.setPopupContentPosition,
      props.setShowPopup,
      props.setCustomLoading,
      props.setFavouriteClicked,
      false,
      setVerifiedWalletDetails,
      verifiedWalletDetails,
      props.generalDataProps,
    ).then(async (res) => {
      if (res) {
        if (Number(amount) <= 0) {
          setCustomPopupPosition("center");
          setCustomPopupContent(null);
          setShowCustomPopup(false);
          errorToast("Invalid amount!", "Amount must be greater than zero(0)");
          return;
        }
        if (
          (Number(walletBalance) > 0 &&
            Number(amount) > Number(walletBalance)) ||
          Number(amount) > Number(selectedCurrency?.balance)
        ) {
          setCustomPopupPosition("center");
          setCustomPopupContent(null);
          setShowCustomPopup(false);
          errorToast("Insufficient balance", "Add more funds and try again.");
          return;
        }
        if (!selectedCurrency?.address || selectedCurrency?.address === "") {
          setCustomPopupPosition("center");
          setCustomPopupContent(null);
          setShowCustomPopup(false);
          errorToast(
            "Invalid currency to withdraw",
            "Select a valid currency and try again",
          );
          return;
        }
        if (Object.values(selcetedBank)?.length <= 1) {
          setCustomPopupPosition("center");
          setCustomPopupContent(null);
          setShowCustomPopup(false);
          errorToast(
            "Invalid Bank/Card",
            "Select a valid bank/card account and try again.",
          );
          return;
        }
        const contr = new web3.eth.Contract(
          SECURITYABI,
          selectedCurrency?.address,
        );
        const cashContract = new Cash(signer, selectedCurrency?.address);
        const decimals = await contr.methods.decimals().call();
        const allowance = await contr.methods
          .allowance(userAddress, selectedCurrency?.address)
          .call();
        const amtFmt = ethers.utils.parseUnits(
          amount?.toString(),
          Number(decimals),
        );

        let isAllowed = false;

        if (cashContract && userAddress) {
          const helpers = {
            setSelectedCurrency,
            setAmount,
            setPopupContent: props.setPopupContent,
            setPopupContentPosition: props.setPopupContentPosition,
            setShowPopup: props.setShowPopup,
            customLoading: props.customLoading,
            setCustomLoading: props.setCustomLoading,
            generalDataProps: props.generalDataProps,
          };
          if (Number(allowance) < Number(amtFmt)) {
            const paymentToken = await authenticatePaymentToken(
              chainId,
              userAddress,
              web3,
              verifiedWalletDetails,
              cashContract,
              "approve",
              [selectedCurrency?.address, amtFmt?.toString()],
              helpers,
              false,
            );
            setCustomPopupPosition("flex-end");
            setCustomPopupContent(
              <PaymentProcess
                title={"Transaction Processing"}
                description={"Approving required contracts for withdrawal"}
              />,
            );
            setShowCustomPopup(true);
            await cashContract
              .approve(
                selectedCurrency?.address,
                amtFmt?.toString(),
                paymentToken?.address
                  ? {
                      paymentToken: paymentToken?.address,
                      apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                      rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                    }
                  : {},
              )
              .then(async (res) => {
                if (res?.status === 0) {
                  isAllowed = true;
                  successToast(
                    "Transaction Successful!",
                    "Approval Successful",
                    `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.transactionHash}`,
                  );
                } else {
                  isAllowed = false;

                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Contracts approval failed."
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup(true);

                  errorToast("Oops Something went wrong", "Approval failed.");
                  return;
                }
              })
              .catch((err) => {
                isAllowed = false;

                setCustomPopupPosition("flex-end");
                setCustomPopupContent(
                  <SuccessPopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    isCustom={true}
                    customTextHeader="Transaction Failed!"
                    customTextFooter="Something went wrong with contracts approval"
                    setFavouriteClicked={props.setFavouriteClicked}
                    isError={true}
                    setCustomPopupPosition={setCustomPopupPosition}
                    setCustomPopupContent={setCustomPopupContent}
                    setShowCustomPopup={setShowCustomPopup}
                  />,
                );
                setShowCustomPopup(true);

                errorToast("Oops Something went wrong", "Approval failed.");
                console.error("approve error: ", err);
                return;
              });
          } else {
            isAllowed = true;
          }

          if (isAllowed) {
            const paymentToken = await authenticatePaymentToken(
              chainId,
              userAddress,
              web3,
              verifiedWalletDetails,
              cashContract,
              "transferFrom",
              [userAddress, selectedCurrency?.address, amtFmt?.toString()],
              helpers,
              false,
            );
            setCustomPopupPosition("flex-end");
            setCustomPopupContent(
              <PaymentProcess
                title={"Processing Withdrawal"}
                description={"Withdrawing funds to your bank/card"}
              />,
            );
            setShowCustomPopup(true);

            await cashContract
              .transferFrom(
                userAddress,
                selectedCurrency?.address,
                amtFmt?.toString(),
                paymentToken?.address
                  ? {
                      paymentToken: paymentToken?.address,
                      apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                      rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                    }
                  : {},
              )
              .then((_res) => {
                if (_res?.status === 0) {
                  setCustomPopupPosition("center");
                  setCustomPopupContent(null);
                  setShowCustomPopup(false);
                  successToast(
                    "Transaction Successful!",
                    "Withdraw funds Successful",
                    `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${_res?.transactionHash}`,
                  );

                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully withdraw funds. You will receive equivalent ${selectedCurrency?.currencySymbol
                        ?.toUpperCase()
                        ?.substring(
                          2,
                          selectedCurrency?.currencySymbol?.length,
                        )} amount in your bank/card soon.`}
                      setFavouriteClicked={props.setFavouriteClicked}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                } else {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Withdraw funds failed."
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup(true);

                  errorToast(
                    "Oops Something went wrong",
                    "Withdraw funds failed.",
                  );
                }
              })
              .catch((err) => {
                errorToast(
                  "Oops Something went wrong",
                  "Withdraw funds failed.",
                );
                setCustomPopupPosition("flex-end");
                setCustomPopupContent(
                  <SuccessPopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    isCustom={true}
                    customTextHeader="Transaction Failed!"
                    customTextFooter="Something went wrong while withdrawing funds"
                    setFavouriteClicked={props.setFavouriteClicked}
                    isError={true}
                    setCustomPopupPosition={setCustomPopupPosition}
                    setCustomPopupContent={setCustomPopupContent}
                    setShowCustomPopup={setShowCustomPopup}
                  />,
                );
                setShowCustomPopup(true);
                console.error("withdraw error: ", err);
              });
          }
        } else {
          errorToast(
            "Oops Something went wrong",
            "Unexpected error. Try again later",
          );
        }
      } else {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
      }
    });
  };

  const handleShowPaymentMethods = async () => {
    await authenticateKYCStatus(
      chainId,
      userAddress,
      web3,
      appKitModal,
      props.setPopupContent,
      props.setPopupContentPosition,
      props.setShowPopup,
      props.setCustomLoading,
      props.setFavouriteClicked,
      false,
      setVerifiedWalletDetails,
      verifiedWalletDetails,
      props.generalDataProps,
    ).then(async (res) => {
      if (res) {
        if (!selectedCurrency?.address || selectedCurrency?.address === "") {
          errorToast(
            "Invalid currency selected",
            "Select a currency to withdraw an try again.",
          );
          return;
        }
        if (Number(amount) <= 0) {
          errorToast("Invalid amount!", "Amount must be greater than zero(0)");
          return;
        }
        if (
          (Number(walletBalance) > 0 &&
            Number(amount) > Number(walletBalance)) ||
          Number(amount) > Number(selectedCurrency?.balance)
        ) {
          errorToast("Insufficient balance", "Add more funds and try again.");
          return;
        }

        props.setPopupContentPosition("flex-end");
        props.setPopupContent(
          <PaymentMethods
            setShowPopup={props.setShowPopup}
            setPopupContent={props.setPopupContent}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
            backClickPopup={
              <WitdrawFunds
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                selectedCurrency={selectedCurrency}
                amount={amount}
              />
            }
            bankSelectText="Withdraw to Bank"
            cardSelectText="Withdraw to Debit/Credit Card"
            generalDataProps={props.generalDataProps}
            selectedCurrency={selectedCurrency}
            linkedBankIds={linkedBankIds}
            bankList={bankList}
            amountInPence={Number(amount) * 100}
            amount={amount}
            isWithdraw={true}
            confirmationFunc={handleWithdrawFunds}
          />,
        );
      }
    });
  };

  return (
    <div className="add-funds-popup">
      {!showAllCurrencies && (
        <div className="add-funds-content">
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              <p className="add-funds-content-header-text">
                {t("payments.withdraw")}
              </p>
            </div>
            <img
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                setNewSearchContent(null);
                props.setPopupContentPosition("center");
                if (props.setFavouriteClicked) {
                  props.setFavouriteClicked(false);
                }
              }}
              className="add-funds-popup-close-icon"
              alt="Close Icon"
              src={popupCloseIcon}
            />
          </div>
          <div className="add-funds-content-footer">
            <div className="add-funds-content-footer-balance-container">
              <p className="add-funds-content-footer-balance-first">
                {t("payments.walletBalance")}:
              </p>
              <p className="add-funds-content-footer-balance-second">
                {selectedCurrency.officialCurrencySymbol}{" "}
                {Number(walletBalance) > 0
                  ? walletBalance.toFixed(4)
                  : selectedCurrency?.balance
                    ? Number(selectedCurrency?.balance)?.toFixed(4)
                    : "0.0000"}
              </p>
            </div>
            <div
              style={{ marginBottom: "12px" }}
              className="asset-info-popup-second-trading-body-line"
            ></div>
            <p className="add-funds-content-footer-text">
              {t("withdrawFunds.enterAmount")}
            </p>
            <div className="a-f-content-footer-input-container">
              <div className="a-f-content-footer-input-group">
                <p className="a-f-content-footer-input-text">
                  {selectedCurrency.officialCurrencySymbol}
                </p>
                <input
                  id="add-funds-popup-input"
                  onInput={(e) => {
                    setAmount(e.target.value);
                    handleAddFundsButtonDisplay();
                  }}
                  type="number"
                  className="a-f-content-footer-input"
                  placeholder="00.00"
                />
              </div>
              <div
                onClick={() => {
                  setShowAllCurrencies(true);
                }}
                className="a-f-content-footer-currencies"
              >
                <div className="a-f-content-footer-currencies-container">
                  <p className="a-f-content-footer-currency">
                    {selectedCurrency.currencySymbol}
                  </p>
                  <img alt="Exand Icon" src={exandIcon} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showAllCurrencies && (
        <div
          style={{ overflow: "auto", marginBottom: "30px" }}
          className="add-funds-content"
        >
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              <img
                onClick={() => {
                  setShowAllCurrencies(false);
                  setNewSearchContent(null);
                }}
                className="add-funds-popup-back-icon"
                alt="Back Icon"
                src={backIcon}
              />
              <p className="add-funds-search-header-text">
                {t("paymentMethods.chooseCurrency")}
              </p>
            </div>
            <img
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                setNewSearchContent(null);
                props.setPopupContentPosition("center");
                if (props.setFavouriteClicked) {
                  props.setFavouriteClicked(false);
                }
              }}
              className="add-funds-popup-close-icon"
              alt="Close Icon"
              src={popupCloseIcon}
            />
          </div>
          <div className="add-funds-content-search">
            <img alt="Search Icon" src={searchIcon} />
            <input
              onInputCapture={() => {
                selectedCurrency.isClicked = false;
              }}
              onInput={(e) => {
                if (e.target.value === "") {
                  setNewSearchContent(null);
                } else {
                  setNewSearchContent(
                    // eslint-disable-next-line array-callback-return
                    getSupportedCurrenciesData.filter((curr) => {
                      if (
                        curr.currencySymbol
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                      ) {
                        curr.searched = e.target.value.toLowerCase();
                        curr.nameArray = curr.currencySymbol.split("");
                        return curr;
                      }
                    }),
                  );
                }
              }}
              className="add-funds-content-search-input"
              type="text"
              placeholder={t("placeholder.currencySearch")}
            />
          </div>
          <div className="add-funds-content-search-result">
            <div className="a-f-content-search-result-header">
              {getSupportedCurrenciesLoading && <p>{t("common.loading")}...</p>}
              {!newSearchContent &&
                getSupportedCurrenciesData
                  .filter(
                    (curr) =>
                      curr.currencySymbol &&
                      curr.officialCurrencySymbol &&
                      curr.currencyName,
                  )
                  .map((curr, idx) => (
                    <div
                      id={`crypto-curencies-${idx}`}
                      key={`crypto-curencies-${idx}`}
                      onClickCapture={() => {
                        curr["isClicked"] = true;
                        setSelectedCurrency(curr);
                      }}
                      onClick={(e) => {
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "a-f-content-search-header-main-active",
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "a-f-content-search-header-main";
                        }
                        const currentTag = document.getElementById(
                          `crypto-curencies-${idx}`,
                        );
                        currentTag.className =
                          "a-f-content-search-header-main-active";
                        handleChooseCurrencyButtonDisplay();
                      }}
                      className="a-f-content-search-header-main"
                    >
                      <div className="a-f-content-search-header-main-container">
                        <div className="a-f-content-search-header-main-content">
                          <div className="a-f-content-search-header-image">
                            <Avatar name={curr.currencySymbol} />
                          </div>
                          <div className="a-f-content-search-header-text-container">
                            <p className="a-f-content-search-header-text-header">
                              {curr.currencySymbol}
                            </p>
                            <p className="a-f-content-search-header-text-footer">
                              {curr.currencyName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

              {newSearchContent &&
                newSearchContent.length > 0 &&
                newSearchContent.map((curr, idx) => (
                  <div
                    id={`crypto-curencies-${idx}`}
                    key={`crypto-curencies-${idx}`}
                    onClickCapture={() => {
                      curr["isClicked"] = true;
                      setSelectedCurrency(curr);
                    }}
                    onClick={(e) => {
                      const previouslyActiveTag =
                        document.getElementsByClassName(
                          "a-f-content-search-header-main-active",
                        );
                      if (previouslyActiveTag.length > 0) {
                        previouslyActiveTag[0].className =
                          "a-f-content-search-header-main";
                      }
                      const currentTag = document.getElementById(
                        `crypto-curencies-${idx}`,
                      );
                      currentTag.className =
                        "a-f-content-search-header-main-active";
                      handleChooseCurrencyButtonDisplay();
                    }}
                    className="a-f-content-search-header-main"
                  >
                    <div className="a-f-content-search-header-main-container">
                      <div className="a-f-content-search-header-main-content">
                        <div className="a-f-content-search-header-image">
                          <Avatar name={curr.currencySymbol} />
                        </div>
                        <div className="a-f-content-search-header-text-container">
                          <p className="a-f-content-search-header-text-header">
                            {curr.nameArray?.length > 0 &&
                              curr.nameArray.map((nm, idx) => (
                                <>
                                  {!curr.searched.includes(
                                    nm.toLowerCase(),
                                  ) && (
                                    <span
                                      key={idx}
                                      style={{
                                        color: "#B6B7C3",
                                      }}
                                    >
                                      {nm}
                                    </span>
                                  )}
                                  {curr.searched.includes(nm.toLowerCase()) && (
                                    <span key={idx}>{nm}</span>
                                  )}
                                </>
                              ))}
                          </p>
                          <p className="a-f-content-search-header-text-footer">
                            {curr.currencyName}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      {showAllCurrencies && (
        <button
          id="choose-currency-popup-button"
          onClick={(e) => {
            if (
              e.target.className.includes("startup-button") &&
              e.target.className !== "startup-button"
            ) {
              e.target.className = "startup-button-click";
              setShowAllCurrencies(false);
              setNewSearchContent(null);
            } else {
              const buttonElement = document.getElementsByClassName(
                "startup-button-active",
              );
              if (buttonElement.length > 0) {
                buttonElement[0].className = "startup-button-click";
                setShowAllCurrencies(false);
                setNewSearchContent(null);
              }
            }
          }}
          className="startup-button"
        >
          <p className="st-button-text">{t("common.proceed")}</p>
        </button>
      )}
      {!showAllCurrencies && (
        <button
          id="withdraw-funds-popup-button"
          onClick={async (e) => {
            if (
              e.target.className.includes("startup-button") &&
              e.target.className !== "startup-button"
            ) {
              e.target.className = "startup-button-click";
              setNewSearchContent(null);

              await handleShowPaymentMethods();
            } else {
              const buttonElement = document.getElementsByClassName(
                "startup-button-active",
              );
              if (buttonElement.length > 0) {
                buttonElement[0].className = "startup-button-click";
                setNewSearchContent(null);

                await handleShowPaymentMethods();
              }
            }
          }}
          className="startup-button"
        >
          <p className="add-funds-popup-a-f-button-text">
            {t("paymentMethods.paymentMethods")}
          </p>
        </button>
      )}
    </div>
  );
};

export default WitdrawFunds;
